<div
  class="sb-field"
  [class.sb-field--disabled]="disabled()"
  [class.sb-field--has-companions]="hasCompanions"
  [class.sb-field--required]="required()"
  [class.sb-field--help-inside]="showHelpEndInside"
  [class.sb-field--help-outside]="showHelpEndOutside">
  @if (isMultiple) {
    @if (label() || showHelpAfterLabel) {
    <div class="sb-field__label-row">
      <label class="mb-0" [attr.for]="id()">
        {{ label() }}
        @if (required()) {
        <span class="red">*</span>
        }
      </label>
      @if (showHelpAfterLabel) {
      <app-info-popover
        class="sb-field__help sb-field__help--after-label"
        [info]="helpText"></app-info-popover>
      }
    </div>
    }
    @if (description()) {
    <div class="sb-field__description">{{ description() }}</div>
    }
  }
  @if (!isMultiple && description()) {
  <div class="sb-field__description" [id]="id() + '-description'">{{ description() }}</div>
  }

  @if (isMultiple) {
  <div
    class="sb-field__control-row"
    [class.sb-field__control-row--with-help]="showHelpEndOutside"
   >
    <div
      class="sb-field__control sb-multi-input"
      [class.sb-multi-input--disabled]="disabled()"
      (click)="focusChipInput()">
      @for (chip of chips; track chip; let i = $index) {
      <span class="sb-multi-input__chip">
        <span class="sb-multi-input__chip-label" [title]="chip">{{ chip }}</span>
        <button
          type="button"
          class="sb-multi-input__chip-remove"
          [disabled]="disabled() || readonly()"
          aria-label="Remove"
          (click)="$event.stopPropagation(); removeChip(i)">
          &times;
        </button>
      </span>
      }
      <input
        #chipInput
        class="sb-multi-input__draft"
        type="text"
        [id]="id()"
        [placeholder]="chips.length ? '' : inputPlaceholder"
        [disabled]="disabled()"
        [readonly]="readonly()"
        [required]="required() && !chips.length"
        [attr.aria-required]="required()"
        [(ngModel)]="draft"
        (keydown)="onDraftKeydown($event)"
        (blur)="onDraftBlur()" />
      @if (showHelpEndInside) {
      <app-info-popover
        class="sb-field__help sb-field__help--end-inside"
        [info]="helpText"></app-info-popover>
      }
    </div>
    @if (showHelpEndOutside) {
    <app-info-popover
      class="sb-field__help sb-field__help--end-outside"
      [info]="helpText"></app-info-popover>
    }
  </div>
  }

  @if (!isMultiple) {
  <div
    class="sb-field__control-row"
    [class.sb-field__control-row--with-help]="showHelpEndOutside"
   >
    <div class="sb-field__control" [class.floating-label]="!isMediaType">
      <!-- Color: the app colour picker; swatch at end; empty = checkerboard -->
      @if (type === 'color') {
      <div class="sb-input-color" [class.sb-input-color--filled]="!!value">
        <input
          class="floating-input sb-input-color__text"
          [class.floating-placeholder]="useFloatingPlaceholder"
          type="text"
          [id]="id()"
          [placeholder]="inputPlaceholder"
          [disabled]="disabled()"
          [readonly]="readonly()"
          [required]="required()"
          [attr.aria-required]="required()"
          [value]="value"
          [attr.value]="value"
          appColorPicker
          [value]="value"
          [showAlpha]="colorAlpha()"
          [allowEmpty]="true"
          (input)="onInput($event)"
          (change)="onInput($event)"
          (blur)="onBlur()" />
        <label [for]="id()">
          {{ label() }}
          @if (required()) {
          <span class="red">*</span>
          }
          @if (showHelpAfterLabel) {
          <app-info-popover
            class="sb-field__help sb-field__help--after-label"
            [info]="helpText"></app-info-popover>
          }
        </label>
      </div>
      }

      <!-- Date, time and datetime: segments typed one part at a time, with a calendar / time popover -->
      @if (isTimeType) {
      <app-sb-date-time-control
        [mode]="timeMode"
        [value]="timeValue"
        [revision]="timeRevision"
        [valueAs]="valueAs()"
        [valueFormat]="valueFormat()"
        [keepUnreadable]="keepUnreadable()"
        [inputId]="id()"
        [label]="label()"
        [ariaLabel]="ariaLabel()"
        [placeholder]="placeholder()"
        [required]="required()"
        [disabled]="disabled()"
        [readonly]="readonly()"
        [min]="min()"
        [max]="max()"
        [quickPicks]="quickPicks()"
        [timeZone]="timeZone()"
        [joinsDate]="joinsDate()"
        [describedBy]="timeDescribedBy"
        [invalid]="!!displayError"
        [helpInside]="showHelpEndInside"
        (valueChange)="onTimeValueChange($event)"
        (stateChange)="onTimeStateChange($event)"
        (touched)="onBlur()"
        (dayPicked)="dayPicked.emit($event)"
        (entryDone)="entryDone.emit($event)">
        @if (showHelpAfterLabel) {
        <app-info-popover
          class="sb-field__help sb-field__help--after-label"
          [info]="helpText"></app-info-popover>
        }
      </app-sb-date-time-control>
      }

      <!-- Image / video: media preview (no text path) -->
      @if (isMediaType) {
      <div class="sb-input-media" [class.sb-input-media--video]="type === 'video'">
        @if (label()) {
        <div class="sb-input-media__label">
          <label [attr.for]="id()" class="mb-0">
            {{ label() }}
            @if (required()) {
            <span class="red">*</span>
            }
          </label>
        </div>
        }
        <div
          class="sb-input-media__frame"
          [class.sb-input-media__frame--empty]="!mediaPreviewUrl"
          [style.aspect-ratio]="mediaAspectRatio">
          @if (allowRemove() && mediaPreviewUrl && !disabled() && !readonly()) {
          <button
            type="button"
            class="sb-input-media__clear"
            aria-label="Remove"
            title="Remove"
            [disabled]="isUploading"
            (click)="clearMedia()">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
          }
          @if (mediaPreviewUrl) {
            @if (type === 'image') {
            <img
              class="sb-input-media__preview"
              [class.sb-input-media__preview--clickable]="mediaClickEnabled"
              [src]="mediaPreviewUrl"
              [attr.role]="mediaClickEnabled ? 'button' : null"
              [attr.tabindex]="mediaClickEnabled ? 0 : null"
              [attr.aria-label]="mediaClickEnabled ? (imageClickAction() === 'browse' ? 'Browse for image' : 'Upload new image') : null"
              (click)="onMediaPreviewClick()"
              (keydown.enter)="onMediaPreviewClick()"
              (keydown.space)="$event.preventDefault(); onMediaPreviewClick()"
              alt="" />
            }
            @if (type === 'video') {
            <video
              class="sb-input-media__preview sb-input-media__preview--video"
              [src]="mediaPreviewUrl"
              controls
              playsinline></video>
            }
          } @else {
            <button
              type="button"
              class="sb-input-media__placeholder"
              [disabled]="disabled() || readonly()"
              [attr.aria-label]="type === 'video' ? 'Choose video' : 'Choose image'"
              (click)="onMediaPlaceholderClick()">
              <i class="fa" [class.fa-image]="type === 'image'" [class.fa-video-camera]="type === 'video'" aria-hidden="true"></i>
              <span>{{ type === 'video' ? 'No video selected' : 'No image selected' }}</span>
            </button>
          }
          @if (showHelpEndInside) {
          <app-info-popover
            class="sb-field__help sb-field__help--end-inside"
            [info]="helpText"></app-info-popover>
          }
          @if (isUploading) {
          <div class="sb-input-media__progress" role="progressbar"
               [attr.aria-valuenow]="uploadProgress" aria-valuemin="0" aria-valuemax="100">
            <div class="sb-input-media__progress-bar" [style.width.%]="uploadProgress"></div>
          </div>
          }
        </div>
        <div class="sb-input-media__actions">
          <app-sb-button
            variant="outline-secondary"
            size="sm"
            [icon]="uploadIcon"
            [label]="uploadLabel"
            [loading]="isUploading"
            [disabled]="disabled() || readonly() || isUploading"
            (clicked)="startUpload()"></app-sb-button>
          <!-- Restrictions are disclosed at the bottom, beside the Upload/Replace button. -->
          @if (showHelpInActions) {
          <app-info-popover
            class="sb-field__help sb-input-media__info"
            [info]="helpText"></app-info-popover>
          }
          <!--
            Media errors sit right after the info icon rather than in the field-wide error bar.
            Deliberately NOT `.invalid-text`: that global class is `position: absolute; top: 34px`,
            which would fling the message to the top of the field.
          -->
          @if (displayError) {
          <div class="sb-input-media__error" role="alert">{{ displayError }}</div>
          }
        </div>
      </div>
      }

      <!-- File: string path + trailing icon row (info / upload-replace / delete) -->
      @if (type === 'file') {
      <div class="sb-input-path">
        <div class="sb-input-path__row">
          <div class="sb-input-native sb-input-path__field">
            <input
              class="floating-input"
              [class.floating-placeholder]="useFloatingPlaceholder"
              type="text"
              [id]="id()"
              [placeholder]="inputPlaceholder"
              [disabled]="disabled()"
              [readonly]="readonly()"
              [required]="required()"
              [attr.aria-required]="required()"
              [value]="value"
              (input)="onInput($event)"
              (blur)="onBlur()" />
            <label [for]="id()">
              {{ label() }}
              @if (required()) {
              <span class="red">*</span>
              }
            </label>
          </div>
          <!-- Trailing icons: delete, upload/replace, info. Plain icons, not boxed buttons. -->
          <div class="sb-input-path__actions">
            @if (allowRemove() && hasMediaValue) {
            <app-sb-button
              variant="link"
              size="sm"
              icon="fa fa-trash"
              [iconOnly]="true"
              ariaLabel="Remove"
              label="Remove"
              extraClass="sb-input-path__icon sb-input-path__icon--delete"
              [disabled]="disabled() || readonly() || isUploading"
              (clicked)="clearMedia()"></app-sb-button>
            }
            <app-sb-button
              variant="link"
              size="sm"
              [icon]="uploadIcon"
              [iconOnly]="true"
              [ariaLabel]="uploadLabel"
              [label]="uploadLabel"
              [loading]="isUploading"
              extraClass="sb-input-path__icon"
              [disabled]="disabled() || readonly() || isUploading"
              (clicked)="startUpload()"></app-sb-button>
            @if (showHelpInActions) {
            <app-info-popover
              class="sb-field__help sb-input-path__info"
              [info]="helpText"></app-info-popover>
            }
          </div>
        </div>
        @if (isUploading) {
        <div class="sb-input-path__progress" role="progressbar"
             [attr.aria-valuenow]="uploadProgress" aria-valuemin="0" aria-valuemax="100">
          <div class="sb-input-path__progress-bar" [style.width.%]="uploadProgress"></div>
        </div>
        }
      </div>
      }

      @if (type === 'file' || isMediaType) {
      <input
        #inlineFileInput
        type="file"
        class="sb-input-path__file-native"
        [attr.accept]="resolvedAccept || null"
        [disabled]="disabled()"
        (change)="onInlineFileSelected($event)" />
      }

      <!--
        Hidden host: modal + selection logic only, opened by the pick button via openBrowse().
        Deliberately NOT `sb-companion-host` — that class sets `display: inline-flex` further down
        the sheet and would win over the hidden rule, showing a stray Browse button.
      -->
      @if (showFileBrowser && (type === 'file' || isMediaType)) {
      <app-file-browser
        #mediaFileBrowser
        class="sb-input-media__browser--hidden"
        [clientId]="clientId()"
        [projectId]="projectId()"
        [type]="fileBrowserType"
        [enableChoose]="true"
        [iconOnly]="false"
        [disabled]="disabled()"
        defaultIcon="fa fa-folder-open"
        (fileSelected)="onFileBrowserSelected($event)">
      </app-file-browser>
      }

      @if (type !== 'color' && type !== 'time' && type !== 'datetime' && type !== 'date' && type !== 'file' && type !== 'image' && type !== 'video') {
        <div class="sb-input-native">
          <input
            class="floating-input"
            [class.floating-placeholder]="useFloatingPlaceholder"
            [type]="htmlType"
            [id]="id()"
            [placeholder]="inputPlaceholder"
            [disabled]="disabled()"
            [readonly]="readonly() || type === 'font'"
            [required]="required()"
            [attr.aria-required]="required()"
            [attr.autocomplete]="autocomplete() || null"
            [attr.aria-label]="ariaLabel() || null"
            [attr.min]="min()"
            [attr.max]="max()"
            [attr.step]="step()"
            [value]="value"
            (input)="onInput($event)"
            (blur)="onBlur()" />
          <label [for]="id()">
            {{ label() }}
            @if (required()) {
            <span class="red">*</span>
            }
            @if (showHelpAfterLabel) {
            <app-info-popover
              class="sb-field__help sb-field__help--after-label"
              [info]="helpText"></app-info-popover>
            }
          </label>
        </div>
      }

      @if (hasCompanions) {
      <div class="sb-field__companions">
        <!-- file/image/video drive the browser from their own single Upload/Replace control. -->
        @if (showFileBrowser && !isMediaType && type !== 'file') {
        <app-file-browser
          class="sb-companion-host"
          [clientId]="clientId()"
          [projectId]="projectId()"
          [type]="fileBrowserType"
          [enableChoose]="true"
          [iconOnly]="true"
          [disabled]="disabled()"
          defaultIcon="fa fa-folder-open"
          (fileSelected)="onFileBrowserSelected($event)">
        </app-file-browser>
        }

        @if (showVariableBrowser()) {
        <app-variables
          class="sb-companion-host"
          [variableClickFor]="resolvedVariableFor"
          [fieldType]="variableFieldType()"
          [format]="variableFormat()"
          [isDisabled]="disabled()"
          [hideText]="true"
          (onVariableClick)="onVariablePicked($event)">
        </app-variables>
        }

        @if (hasConditionBuilder) {
        <app-sb-text-condition-button
          class="sb-companion-host"
          [target]="id()"
          [iconOnly]="true"
          [disabled]="disabled() || readonly()">
        </app-sb-text-condition-button>
        }

        @if (showFontBrowser() || type === 'font') {
        <app-font-browser
          class="sb-companion-host"
          [projectId]="projectId()"
          [iconOnly]="true"
          [disabled]="disabled()"
          (fontSelected)="onFontBrowserSelected($event)">
        </app-font-browser>
        }

        @if (showHelpEndInside && !isMediaType) {
        <app-info-popover
          class="sb-field__help sb-companion-info"
          [info]="helpText"></app-info-popover>
        }
      </div>
      }

      @if (showHelpEndInside && !hasCompanions && !isMediaType) {
      <app-info-popover
        class="sb-field__help sb-field__help--end-inside"
        [info]="helpText"></app-info-popover>
      }
    </div>
    @if (showHelpEndOutside) {
    <app-info-popover
      class="sb-field__help sb-field__help--end-outside"
      [info]="helpText"></app-info-popover>
    }
  </div>
  }

  @if (isMultiple && (showFileBrowser || showFontBrowser() || showVariableBrowser() || type === 'font')) {
  <div class="sb-field__label-row mt-1">
    @if (showFileBrowser) {
    <app-file-browser
      class="sb-companion-host"
      [clientId]="clientId()"
      [projectId]="projectId()"
      [enableChoose]="true"
      [iconOnly]="true"
      [disabled]="disabled()"
      defaultIcon="fa fa-folder-open"
      (fileSelected)="onFileBrowserSelected($event)">
    </app-file-browser>
    }
    @if (showVariableBrowser()) {
    <app-variables
      class="sb-companion-host"
      [variableClickFor]="resolvedVariableFor"
      [fieldType]="variableFieldType()"
      [format]="variableFormat()"
      [isDisabled]="disabled()"
      [hideText]="true"
      (onVariableClick)="onVariablePicked($event)">
    </app-variables>
    }
    @if (showFontBrowser() || type === 'font') {
    <app-font-browser
      class="sb-companion-host"
      [projectId]="projectId()"
      [iconOnly]="true"
      [disabled]="disabled()"
      (fontSelected)="onFontBrowserSelected($event)">
    </app-font-browser>
    }
  </div>
  }

  <!-- Media types render their own error inline after the info icon; everything else uses this bar. -->
  @if (displayError && !isMediaType) {
  <div class="bar error-brd sb-field__error" [id]="id() + '-error'">
    <div class="invalid-text">{{ displayError }}</div>
  </div>
  }

  @if (timeNotice) {
  <div class="sb-field__notice">{{ timeNotice }}</div>
  }

  @if (hasConditionBuilder) {
  <app-sb-text-condition-hint
    [text]="value"
    [target]="id()"
    [disabled]="disabled() || readonly()">
  </app-sb-text-condition-hint>
  }
</div>
